import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { useState } from "react"
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom"
import { customerQueryClientConfig } from "./query-client.js"
import { DashboardPage } from "./routes/dashboard-page.js"
import { JoinPage, LinkExpiredPage, MemberHomePage } from "./routes/join-page.js"
import { OrderPage } from "./routes/order-page.js"
import { PurchasePage } from "./routes/purchase-page.js"
import { SignupPage } from "./routes/signup-page.js"
import "./i18n.js"

export function CustomerApp() {
  const [queryClient] = useState(() => new QueryClient(customerQueryClientConfig))

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route index element={<PurchasePage />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="order" element={<OrderPage />} />
          <Route path="order/:key" element={<OrderPage />} />
          <Route path="signup/:slug" element={<SignupPage />} />
          <Route path="join/:signupId" element={<JoinPage />} />
          <Route path="home" element={<MemberHomePage />} />
          <Route path="link-expired" element={<LinkExpiredPage />} />
          <Route path="account" element={<Navigate replace to="/dashboard" />} />
          <Route path="*" element={<Navigate replace to="/" />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  )
}
